import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { Button, Card, CardBody, CardHeader, Col, Container, DatePicker, Form, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, Modal, ModalBody, Row } from 'shards-react';
import { formatNumberAmount } from '../../../utils/general';
import { setDateForHeader, setDateForTable, setDateForTableInHrMinSec, setInputDate } from '../../../utils/date';
import { get_currency_list, get_worker_list_by_client } from '../../../redux/actions/subscriber/invoice';
import ReactTable from 'react-table';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { GeneralSettingsKeys, NavgationPageLocationKey } from '../../../utils/constants';
import ConfirmAlert from '../../../components/common/ConfirmAlert';
import { get_client_list } from '../../../redux/actions/user';
import { delete_uploaded_data, get_import_data_status_list, get_import_log_by_refnum, get_import_log_status_list, import_valid_records, reset_importlog_detail } from '../../../redux/actions/subscriber/importLog';
import { get_pay_schedule_list, get_payperiod_list } from '../../../redux/actions/subscriber/payroll';

const ImportLogDetails = ({
    importResultData,
    get_client_list, get_worker_list_by_client,
    clientList, workerList, payScheduleList, get_pay_schedule_list,
    reset_importlog_detail, get_import_log_by_refnum,
    delete_uploaded_data, import_valid_records,
    get_payperiod_list, payPeriodList,
    importResultStatus, get_import_data_status_list, 
}) => {
    const [initialState, setInitialState] = useState({
        refNum: 0,
        userId: '',
        workerName: '',
        clientName: '',
        status: '',
        flterStatus: '',
        payPeriodId: '',
        payScheduleId: '',
        from: '',
        to: '',

        clientId: 0,
        workerId: 0,

        actionBy: '',
        createdAt: '',
        createdBy: '',
        dateTimeActioned: '',
        duplicatesIncluded: '',
        importType: '',
        numberOfInvalidRecords: 0,
        numberOfValidRecords: 0,
        payPeriod: '',
        paySchedule: '',
        filename: '',
        subscriberId: 0,
        totalCppEmployee: 0,
        totalCppEmployer: 0,
        totalEiEmployee: 0,
        totalEiEmployer: 0,
        totalEmployerTotal: 0,
        totalFederalTax: 0,
        totalProvMed: 0,
        totalWcb: 0,
        updatedAt: '',
        updatedBy: '',

        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 10,
        bulkAction: '',
    })

    const [formData, setFormData] = useState(initialState)
    const [tableItemData, setTableItemData] = useState([]);

    const [openModal, setOpenModal] = useState(false);
    const location = useLocation();
    const [stateId, setStateId] = useState(0);
    const history = useHistory();
    const [dropdownData, setDropdownData] = useState([]);
    const [filterPayPeriod, setFilterPayPeriod] = useState([]);

    const statusListOption = (importResultStatus || []).map(status => <option key={status} value={status}>{status}</option>)
    const clientListOptions = (clientList || []).map(client => <option key={client.clientName + client.clientId} value={client.clientName}>{client.clientName}</option>)
    const workerListOptins = Number(formData.clientName) !== 0 && workerList.map(worker => <option key={worker.name + worker.userId} value={worker.name}>{worker.name}</option>)
    const payScheduleListOptions = (payScheduleList || []).map(paySchedule => <option key={paySchedule.payScheduleName + paySchedule.payScheduleRefNum} value={paySchedule.payScheduleRefNum}>{paySchedule.payScheduleName}</option>)

    const [confirmAlert, setConfirmAlert] = useState({
        confirmMsg: "",
        visible: false,
        onConfirm: null
    });

    const setStatusColor = (status) => {
        if (status === undefined || status === null || status === '')
            return false;

        return (<> <span className={status === 'Valid' ? 'status-green' : 'status-red'}>{status}</span> </>
        )
    }

    const tableColumns = [
        {
            Header: "Status",
            accessor: "status",
            minWidth: 80,
            Cell: row => setStatusColor(row.original.status),
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>Total</span>
            </div>
        },
        {
            Header: "Message",
            accessor: "message",
            minWidth: 120,
            Cell: row => <span className="w-100" title={row.original.message}>{row.original.message}</span>,
            Footer: <div className="d-flex w-100 justify-content-start text-nowrap">
                <span>(Filtered Data) </span>
            </div>
        },
        {
            Header: "User ID",
            accessor: "userId",
            minWidth: 80,
            Cell: row => <span className="w-100" title={row.original.userId}>{row.original.userId}</span>
        },
        {
            Header: "Client",
            accessor: "clientName",
            minWidth: 180,
            Cell: row => <span className="w-100 text-left" title={row.original.clientName}>{row.original.clientName}</span>
        },
        {
            Header: "Worker Name",
            accessor: "userName",
            minWidth: 150,
            Cell: row => <span className="w-100" title={row.original.userName}>{row.original.userName}</span>
        },
        {
            Header: "Date",
            accessor: "date",
            minWidth: 100,
            Cell: row => setDateForTable(row.original.date)
        },
        {
            Header: "PPE",
            accessor: "payPeriodEnding",
            minWidth: 90,
        },
        {
            Header: "Employee Name",
            accessor: "employeeName",
            minWidth: 150,
        },
        {
            Header: "Employee Number",
            accessor: "employeeNumber",
            minWidth: 100,
        },
        {
            Header: "CPP Employee",
            accessor: "cppEmployee",
            minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.cppEmployee, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(formData.totalCppEmployee, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "CPP Employer",
            accessor: "cppEmployer",
            minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.cppEmployer, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(formData.totalCppEmployer, 'en-US', 2, 2)}</span>
            </div>
        },

        {
            Header: "EI Employee",
            accessor: "eiEmployee",
            minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.eiEmployee, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(formData.totalEiEmployee, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "EI Employer",
            accessor: "eiEmployer",
            minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.eiEmployer, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(formData.totalEiEmployer, 'en-US', 2, 2)}</span>
            </div>
        },

        {
            Header: "Federal Tax",
            accessor: "federalTax",
            minWidth: 80,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.federalTax, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(formData.totalFederalTax, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Prov Med",
            accessor: "provMed",
            minWidth: 80,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.provMed, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(formData.totalProvMed, 'en-US', 2, 2)}</span>
            </div>
        },

        {
            Header: "WCB",
            accessor: "wcb",
            minWidth: 80,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.wcb, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(formData.totalWcb, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Employer Total",
            accessor: "employerTotal",
            minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.employerTotal, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(formData.totalEmployerTotal, 'en-US', 2, 2)}</span>
            </div>
        },
        // {
        //     Header: "Amount",
        //     accessor: "amount",
        //     minWidth: 110,
        //     Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.amount, 'en-US', 2, 2)}</span>
        // },
    ]

    const reset = () => {
        setFormData({ ...formData, userId: '', clientName: "", workerName: '', status: '', payPeriodId: '', payScheduleId: '', from: '', to: '' })
        get_import_log_by_refnum(formData.refNum, '', '', '', '', '', '', '', '')
    }

    const onSearch = (e) => {
        e.preventDefault()
        get_import_log_by_refnum(formData.refNum, formData.userId, formData.clientName, formData.workerName,
            formData.flterStatus, formData.payPeriodId, formData.payScheduleId,
            setInputDate(formData.from), setInputDate(formData.to))
    }

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    // const groupAndSetDropDownVal = (data) => {
    //     if (data != null) {
    //         const uniqueNames = [...new Set(data.map((item) => item.payPeriod))];
    //         let options = uniqueNames.map(item => <option key={item} value={item}>{item}</option>)
    //         setDropdownData(options);
    //     }
    // }

    useEffect(() => {
        if (Object.keys(importResultData).length > 0) {
            setTableItemData([...importResultData.payrollTaxLogList ?? []])
            //groupAndSetDropDownVal(importResultData.payrollTaxLogList);

            //Prepare main details
            setFormData({
                ...formData,
                actionBy: importResultData?.actionBy,
                createdAt: importResultData?.createdAt,
                createdBy: importResultData?.createdBy,
                dateTimeActioned: importResultData?.dateTimeActioned,
                duplicatesIncluded: importResultData?.duplicatesIncluded,
                filename: importResultData?.filename,
                importType: importResultData?.importType,
                numberOfInvalidRecords: importResultData?.numberOfInvalidRecords,
                numberOfValidRecords: importResultData?.numberOfValidRecords,
                payPeriod: importResultData?.payPeriod,
                paySchedule: importResultData?.paySchedule,
                refNum: importResultData?.refNum,
                status: importResultData?.status,
                subscriberId: importResultData?.subscriberId,
                totalCppEmployee: importResultData?.totalCppEmployee,
                totalCppEmployer: importResultData?.totalCppEmployer,
                totalEiEmployee: importResultData?.totalEiEmployee,
                totalEiEmployer: importResultData?.totalEiEmployer,
                totalEmployerTotal: importResultData?.totalEmployerTotal,
                totalFederalTax: importResultData?.totalFederalTax,
                totalProvMed: importResultData?.totalProvMed,
                totalWcb: importResultData?.totalWcb,
                updatedAt: importResultData?.updatedAt,
                updatedBy: importResultData?.updatedBy,
            })

        }
    }, [importResultData]);

    useEffect(() => {
        if (stateId === 0) {
            if (location.state !== undefined && location.state !== null) {
                //Take from state
                setStateId(location.state?.refNum);
                get_import_log_by_refnum(location.state?.refNum, '', '', '', '', '', '', '', '')
            }
            else if (localStorage.getItem(NavgationPageLocationKey.ImportLogAddEdit) !== null) {
                //Take from local storage 
                setStateId(localStorage.getItem(NavgationPageLocationKey.ImportLogAddEdit));
                get_import_log_by_refnum(localStorage.getItem(NavgationPageLocationKey.ImportLogAddEdit), '', '', '', '', '', '', '', '')
                const newState = { refNum: localStorage.getItem(NavgationPageLocationKey.ImportLogAddEdit) };
                history.push(location.pathname, newState);
                localStorage.removeItem(NavgationPageLocationKey.ImportLogAddEdit);
            }
        }
        get_client_list();
        get_payperiod_list();
        get_pay_schedule_list();
        get_import_data_status_list();
        return reset_importlog_detail;

    }, []);

    useEffect(() => {
        if (formData.clientName !== "") {
            var id = clientList.filter(x => x.clientName === formData.clientName)[0]?.clientId;
            get_worker_list_by_client(id);
        }
    }, [formData.clientName])

    const onSubmit = async (e) => {
        e.preventDefault();
        if (e.nativeEvent.submitter.name === 'yes') {

            const update = await import_valid_records(formData.refNum);
            if(update) {
                //Navigate to listing screen
                history.push({ pathname: `/import-logs`});
            }
            else {
                toggle();
            }
        }
        else {
            toggle();
        }
    }

    const toggle = () => {
        setOpenModal(!openModal);
        setFormData({ ...formData, bulkAction: '' });
    }

    const deleteUploadedData = async () => {        
        const update = await delete_uploaded_data(formData.refNum);
        history.push({ pathname: `/import-logs`});
    }

    const importValidData = async (e) => {
        toggle();   
    }

    useEffect(() => {
        setFormData({ ...formData, payPeriodId: 0});
        if(formData.payScheduleId !== null && formData.payScheduleId !== ""){
            let filterData = payPeriodList.filter((x) => { return x.payScheduleRefNum == formData.payScheduleId })
                .map(item => <option key={item.refNum} value={item.refNum}>{item.payPeriodName}</option>)
            setFilterPayPeriod(filterData)
        }
        else {
            setFilterPayPeriod([])
        }
    }, [formData.payScheduleId])

    return (

        <Container fluid className="main-content-container px-4 pb-4 bg-white mt-2">
            <ConfirmAlert confirmAlert={confirmAlert} setConfirmAlert={setConfirmAlert} />
            <Modal size="md" fade={false} style={{ width: '500px' }} backdrop={false} className="d-flex align-items-center justify-content-center w-auto h-100" open={openModal} toggle={toggle}>
                <div className='d-flex w-100'>
                    <div className="d-flex justify-content-start p-1 mx-2 custom_maxwidth_85">
                        <label className='font-weight-bold'>Confirm Data Import</label>
                    </div> 
                    <div className="d-flex justify-content-end p-1 mx-2 custom_maxwidth_9"><i class="fa-solid fa-xmark primary-text bg-white" role="button" onClick={toggle}></i></div>
                </div>
                
                <ModalBody className="px-4" >
                    <div>
                        <Form onSubmit={onSubmit}>
                            <Row className="w-100">
                                <Col lg="12" className="my-auto pb-4 tex-center pl-2 px-0">
                                    <label className="font-weight-bold my-auto">
                                        Are you sure you want to import {formData.numberOfValidRecords} Records?
                                    </label>
                                </Col>
                                <Col lg="12" className="d-flex flex-row justify-content-center">
                                    <div className="d-flex flex-row justify-content-between">
                                        <Button name="yes" type="submit" className="px-4 mx-2">Confirm Import</Button>
                                        <Button name="cancel" onClick={toggle} className="px-4 mx-2">Close</Button>
                                    </div>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </ModalBody>
            </Modal>

            <Card>
                <CardHeader className="px-4">
                    <div className="page-header tableSearch client_invoice flex-column flex-md-row py-2 d-flex btn-accent mt-2">

                        <div className="d-flex align-items-center ml-2 mt-1 mb-1 p-1 bg-white"></div>

                        <div className="d-flex align-items-center p-2 ml-1 custom_maxwidth_9 justify-content-center">
                            <div className="d-flex align-items-center p-2 invRefBox">
                                {'IMP-' + formData.refNum}
                            </div>
                        </div>

                        <div className="d-flex align-items-center p-2 mb-0" style={{width: "24%"}}>
                            <div class="pl-0 pr-0 " style={{width: "35%"}}>
                                <label style={{ marginBottom: 0 }}><i>Import Type:</i> </label>
                            </div>
                            <div class="pl-0 pr-0" style={{ width: "75%" }}>
                                <span>{formData.importType}</span>
                            </div>
                        </div>

                        <div className="d-flex align-items-center p-2 mb-0" style={{width: "16%"}}>
                            <div style={{width: "40%"}}>
                                <label style={{ marginBottom: 0 }}><i>Start Date:</i> </label>
                            </div>
                            <div className='' style={{ width: "70%" }}>
                                <span>{setDateForHeader(formData.createdAt)}</span>
                            </div>
                        </div>

                        <div className="d-flex align-items-center p-2 mb-0" style={{width: "28%"}}>
                            <div style={{width: "35%"}}>
                                <label style={{ marginBottom: 0 }}><i>{formData.status} By:</i> </label>
                            </div>
                            <div className='' style={{ width: "75%" }}>
                                <span>{formData.actionBy}</span>
                            </div>
                        </div>

                        <div className="d-flex align-items-center p-2 mb-0" style={{width: "22%"}}>
                            <div style={{width: "35%"}}>
                                <label style={{ marginBottom: 0 }}><i>{formData.status} On:</i> </label>
                            </div>
                            <div className='' style={{ width: "75%" }}>
                                <span>{setDateForTableInHrMinSec(formData.dateTimeActioned)}</span>
                            </div>
                        </div>
                    </div>
                </CardHeader>

                <CardBody className="paddingtopzero w-100">
                    <Row className="px-2">
                        <Col lg="6" className="">
                            <Row>
                                <Col lg="12" className="form-group m-0 p-2">
                                    <Row className="ml-2">
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Pay Schedule:</label>
                                        </Col>
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-2">
                                            {/* currency requires to add */}
                                            <label className=""> {formData.paySchedule} </label>
                                        </Col>

                                        <Col lg="4" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Number of Valid Records:</label>
                                        </Col>
                                        <Col lg="2" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className=""> {formData.numberOfValidRecords}</label>
                                        </Col>
                                    </Row>
                                    <Row className="ml-2">
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Pay Period:</label>
                                        </Col>
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className=""> {formData.payPeriod}</label>
                                        </Col>

                                        <Col lg="4" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Number of Invalid Records:</label>
                                        </Col>
                                        <Col lg="2" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className=""> {formData.numberOfInvalidRecords} </label>
                                        </Col>
                                    </Row>

                                    <Row className="ml-2">
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Duplicates Included:</label>
                                        </Col>
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className=""> {formData.duplicatesIncluded === true ? 'Yes' : 'No'}</label>
                                        </Col>

                                        <Col lg="6">
                                            <Button className="mx-2 py-2 my-2 btn btn-accent btn-sm" onClick={importValidData}>
                                                <i class="fa fa-download" aria-hidden="true"></i> &nbsp; Import Valid Records
                                            </Button>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg="6" className="">
                            <Row>
                                <Col lg="12" className="form-group m-0 p-2">
                                    <Row className="ml-2">
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">Status:</label>
                                        </Col>
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className=""> {formData.status} </label>
                                        </Col>
                                        <Col lg="6" className="form-group my-auto pt-2 pr-1 pl-2">
                                            {/* btn btn-danger */}
                                            <Button className="" onClick={deleteUploadedData} theme="danger">
                                                <i class="fa fa-trash" aria-hidden="true"></i> &nbsp; Delete Uploaded Data
                                            </Button>
                                        </Col>
                                    </Row>
                                    <Row className="ml-2">
                                        <Col lg="3" className="form-group my-auto pt-2 pr-1 pl-1">
                                            <label htmlFor="clientId" className="">File Name:</label>
                                        </Col>
                                        <Col lg="4" className="form-group my-auto pt-2 pr-1 pl-2">
                                            <label className=""> {formData.filename}</label>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex justify-content-end bg-white mt-4 ">

                        <div className="d-flex align-items-center p-2">
                            <FormInput
                                name='userId' value={formData.userId}
                                onChange={onChange} placeholder="User Id"
                            />
                        </div>

                        <div className="d-flex align-items-center p-2" style={{ width: "15%" }}>
                            <FormSelect
                                id="clientName"
                                name="clientName"
                                value={formData.clientName}
                                onChange={onChange}>
                                <option key={`client`} value=''>Client</option>
                                {clientListOptions}
                            </FormSelect>
                        </div>

                        <div className="d-flex align-items-center p-2" style={{ width: "20%" }}>
                            <FormSelect
                                id="workerName"
                                name="workerName"
                                value={formData.workerName}
                                onChange={onChange}>
                                <option key={`workerId`} value=''>Worker Name</option>
                                {workerListOptins}
                            </FormSelect>
                        </div>

                        <div className="d-flex align-items-center p-2" style={{ width: "10%" }}>
                            <FormSelect
                                id="flterStatus"
                                name="flterStatus"
                                value={formData.flterStatus}
                                onChange={onChange}>
                                <option key={`status`} value=''>Status</option>
                                {statusListOption}
                            </FormSelect>
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <FormSelect
                                id="payScheduleId"
                                name="payScheduleId"
                                value={formData.payScheduleId}
                                onChange={onChange}>
                                <option key={`payScheduleId`} value=''>Select Pay Schedule</option>
                                {payScheduleListOptions}
                            </FormSelect>
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <FormSelect
                                id="payPeriodId"
                                name="payPeriodId"
                                value={formData.payPeriodId}
                                onChange={onChange}>
                                <option key={`payPeriodId`} value=''>Select Pay Period</option>
                                {filterPayPeriod}
                                {/* {dropdownData} */}
                            </FormSelect>
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <div className="d-flex align-items-center p-2">
                                <InputGroup className={classNames("d-flex", "my-auto", "date-range")}>
                                    <DatePicker
                                        name="from"
                                        size="sm"
                                        selected={formData.from}
                                        onChange={(date) => {
                                            setFormData({ ...formData, from: date })
                                        }}
                                        dateFormat='yyyy-MM-dd'
                                        placeholderText="From"
                                        dropdownMode="select"
                                        autoComplete='off'
                                        className="text-center"
                                    />
                                    <DatePicker
                                        name="to"
                                        size="sm"
                                        selected={formData.to}
                                        onChange={(date) => {
                                            setFormData({ ...formData, to: date })
                                        }}
                                        dateFormat='yyyy-MM-dd'
                                        placeholderText="To"
                                        dropdownMode="select"
                                        autoComplete='off'
                                        className="text-center"
                                        popperPlacement="top-end"
                                    />
                                    <InputGroupAddon type="append">
                                        <InputGroupText>
                                            <i className="material-icons">&#xE916;</i>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-end p-2">
                            <Button className="mx-2 py-2 my-2" size='sm' name="Search" theme="accent"
                                onClick={onSearch}>Search</Button>
                            <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={reset} >
                                Reset
                            </Button>
                        </div>
                    </div>
                    <Card className="tableCard p-0">
                        <CardHeader className="p-0">
                            <Container fluid className="file-manager__filters border-bottom">
                                <Row>
                                    {/* Filters :: Page Size */}

                                    <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                                        {/* <span>
                                            <FormSelect size="sm" name='bulkAction' className="w-100"
                                                value={formData.bulkAction} onChange={onChange}
                                            >
                                                <option key="bulkActions0" value="">Bulk Actions</option>
                                                <option key="download2" value={DOWNLOAD}>Download</option>
                                                <option key="changeStatus1" value={CHANGE_STATUS}>Change Status</option>
                                            </FormSelect>
                                        </span> */}
                                    </Col>
                                    <Col lg="3" className="d-flex align-items-center">
                                    </Col>
                                    <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                                    </Col>

                                    <Col lg="1"
                                        className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                                        <span>Show</span>
                                        <FormSelect
                                            size="sm"
                                            name='pageSize'
                                            value={formData.pageSize}
                                            onChange={onChange}
                                        >
                                            {formData.pageSizeOptions.map((size, idx) => (
                                                <option key={idx} value={size}>
                                                    {size} rows
                                                </option>
                                            ))}
                                        </FormSelect>
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                        <CardBody className="p-0">
                            <div className="">
                                <ReactTable
                                    columns={tableColumns}
                                    data={tableItemData}
                                    pageSize={Number(formData.pageSize)}
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    noDataText="No results found"
                                    previousText={<i class='fa fa-chevron-left' aria-hidden='true'></i>}
                                    nextText={<i class='fa fa-chevron-right' aria-hidden='true'></i>}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </CardBody>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    currencyList: state.invoice.currencyList,
    clientList: state.user.clientList,
    workerList: state.invoice.workerList,
    payScheduleList: state.payroll.payScheduleList,
    importResultData: state.importLog.importResultData,
    payPeriodList: state.payroll.payPeriodList,
    importResultStatus: state.importLog.importResultStatus,
});
export default connect(mapStateToProps, {
    get_import_log_by_refnum,
    delete_uploaded_data,
    import_valid_records,
    reset_importlog_detail,
    get_payperiod_list,
    get_client_list,
    get_worker_list_by_client,
    get_pay_schedule_list,
    get_import_data_status_list,
})(ImportLogDetails);
